
import React from 'react';
import { ICONS } from '../constants';

const SolutionDetail: React.FC<{ title: string; subtitle: string; description: string; outcomes: string[]; icon: React.ReactNode }> = ({ title, subtitle, description, outcomes, icon }) => (
  <div className="py-12 sm:py-24 border-b border-white/5 grid lg:grid-cols-2 gap-10 sm:gap-20 items-center last:border-0">
    <div className="space-y-6 sm:space-y-8">
      <div className="w-12 h-12 sm:w-16 sm:h-16 bg-white/5 rounded-2xl flex items-center justify-center text-[#32dee6]">
        {icon}
      </div>
      <div className="space-y-2 sm:space-y-4">
        <div className="mono text-[9px] sm:text-[10px] font-bold text-[#32dee6] tracking-[0.3em] sm:tracking-[0.4em] uppercase">{subtitle}</div>
        <h2 className="text-3xl sm:text-5xl md:text-7xl font-extrabold tracking-tighter text-white uppercase">{title}</h2>
      </div>
      <p className="text-lg sm:text-xl text-gray-400 font-light leading-relaxed">{description}</p>
    </div>
    <div className="bg-white/[0.02] p-8 sm:p-12 rounded-[2rem] sm:rounded-[3rem] border border-white/5 space-y-6 sm:space-y-8">
      <h4 className="mono text-[8px] sm:text-[10px] font-bold text-white/40 uppercase tracking-[0.3em] sm:tracking-[0.4em]">Operational_Outcomes</h4>
      <div className="space-y-4 sm:space-y-6">
        {outcomes.map((outcome, idx) => (
          <div key={idx} className="flex items-center space-x-3 sm:space-x-4">
            <div className="w-1.5 h-1.5 rounded-full bg-[#32dee6] shadow-[0_0_10px_#32dee6]"></div>
            <span className="text-base sm:text-lg text-white font-medium">{outcome}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

const SolutionsPage: React.FC = () => {
  return (
    <div className="pt-32 sm:pt-52 pb-16 sm:pb-32 px-4 sm:px-6">
      <div className="container mx-auto">
        <header className="mb-16 sm:mb-32">
          <div className="mono text-[9px] sm:text-[10px] font-bold text-[#32dee6] tracking-[0.3em] sm:tracking-[0.4em] uppercase mb-4 sm:mb-6">Voice_Infrastructure_v4</div>
          <h1 className="text-5xl sm:text-7xl md:text-9xl font-black tracking-tighter text-white leading-none uppercase">
            3-Pillar <br />
            <span className="gradient-text">Core.</span>
          </h1>
        </header>

        <div className="space-y-4">
          <SolutionDetail 
            title="AI Receptionist"
            subtitle="Pillar_01 // The FrontDesk"
            description="Built and deployed in under 48 hours. Powered by LaunchScript AI—our custom GPT trained on over 3M high-converting sales conversations. Handles FAQs, live calendar booking, and complex objection handling."
            icon={<ICONS.Phone />}
            outcomes={["LaunchScript AI Integration", "Sentiment-Based Bucketing", "FAQs & Objection Handling", "Direct Calendar Booking"]}
          />

          <SolutionDetail 
            title="FrontDesk SMS"
            subtitle="Pillar_02 // Automated Nurture"
            description="We handle re-engaging leads instantly with missed call text-back and smart AI that follows up with prospects to book appointments directly on your calendar."
            icon={<ICONS.Zap />}
            outcomes={["8-Touch 48h Workflow", "Anti-Bot Human Simulation", "Google Review Filtering", "Automatic Hang-up Recovery"]}
          />

          <SolutionDetail 
            title="24/7 Coverage"
            subtitle="Pillar_03 // Autonomy"
            description="Total peace of mind. Your business never sleeps, ensuring 100% lead contact during nights, weekends, and holidays. Build a predictable pipeline while staying offline."
            icon={<ICONS.Shield />}
            outcomes={["Holiday/After-Hours Uptime", "Real-time Lead Summaries", "Predictable Growth Scaling", "Zero Manual Management"]}
          />
        </div>
      </div>
    </div>
  );
};

export default SolutionsPage;